import { unwrapResult } from '@reduxjs/toolkit';
import {
  AssignProductsToCategoriesRequestDto,
  ProductDetailsResponseDto,
} from '@tiendanube/common';
import ProductDetailsResponseApiV2Dto from '@tiendanube/common/src/domains/catalog/interfaces/ProductDetailsResponseApiV2';
import { useAppDispatch } from 'App/store';
import {
  MassActionParamsInterface,
  UpdateProductsParamsInterface,
} from 'domains/Catalog/Products/productsServices';
import {
  editPricesProduct as editPricesProductAction,
  assignCategories as assignCategoriesAction,
  updateProducts as updateProductsAction,
  updateProductsVisibilityWithUnstableApi as updateProductsVisibilityWithUnstableApiAction,
  deleteProducts as deleteProductsAction,
  EditPricesProductsDto,
  productsMassAction as productsMassActionAction,
} from 'domains/Catalog/Products/productsSlice';

export interface UseActionProducts {
  editPriceProduct: (
    payload: EditPricesProductsDto,
  ) => Promise<{ token: string }>;
  assignCategories: (
    payload: AssignProductsToCategoriesRequestDto,
  ) => Promise<void>;
  updateProducts: (
    payload: UpdateProductsParamsInterface,
  ) => Promise<ProductDetailsResponseDto[]>;
  updateProductsVisibilityWithUnstableApi: (
    payload: UpdateProductsParamsInterface,
  ) => Promise<ProductDetailsResponseApiV2Dto>;
  deleteProducts: (
    payload: string[],
    canUseUnstableApiV2: boolean,
  ) => Promise<void>;
  productsMassAction: (
    payload: MassActionParamsInterface,
  ) => Promise<{ token: string }>;
}

function useActionProducts(): UseActionProducts {
  const dispatch = useAppDispatch();

  const editPriceProduct = async (payload: EditPricesProductsDto) => {
    const result = await dispatch(editPricesProductAction(payload));
    return unwrapResult(result);
  };

  const assignCategories = async (
    payload: AssignProductsToCategoriesRequestDto,
  ) => {
    const result = await dispatch(assignCategoriesAction(payload));
    return unwrapResult(result);
  };

  const productsMassAction = async (payload: MassActionParamsInterface) => {
    const result = await dispatch(productsMassActionAction(payload));
    return unwrapResult(result);
  };

  const updateProducts = async (payload: UpdateProductsParamsInterface) => {
    const result = await dispatch(updateProductsAction(payload));
    return unwrapResult(result);
  };

  const updateProductsVisibilityWithUnstableApi = async (
    payload: UpdateProductsParamsInterface,
  ) => {
    const result = await dispatch(
      updateProductsVisibilityWithUnstableApiAction(payload),
    );
    return unwrapResult(result);
  };

  const deleteProducts = async (
    payload: string[],
    canUseUnstableApiV2: boolean,
  ) => {
    const result = await dispatch(
      deleteProductsAction({ ids: payload, canUseUnstableApiV2 }),
    );
    return unwrapResult(result);
  };

  return {
    editPriceProduct,
    productsMassAction,
    assignCategories,
    updateProducts,
    updateProductsVisibilityWithUnstableApi,
    deleteProducts,
  };
}

export default useActionProducts;
